export default function getParent(lista, parentId) {
    return lista?.find(elemento => elemento.id === parentId);
}

export function getParentMap(map, id) {
    return map.get(id);
}